import PageForm from '../../../components/pageForm/PageForm';
import SubNavbar from '../../../components/SubNavbar/SubNavbar';
import BodyVivierRatingTempWorker from './components/content/body.vivier-rating-temp-worker';
import { useState } from 'react';
import StyledInput from '../../../components/styledInput/StyledInput';
import { SearchLoop, Filter } from '../../../assets/icons';
import FilterDropdown from '../../../components/filter/FilterDropdown';
import MediaQuery from 'react-responsive';
import Button from '../../../components/button';
import BottomSheet from '../../../components/bottomSheet/BottomSheet';

const STATUS_OPTIONS = [
  { value: 'untreated', label: 'À traiter', checked: true },
  { value: 'treated', label: 'Traité', checked: false },
];

const VivierRatingTempWorker = () => {
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState(STATUS_OPTIONS);
  const treated = statusFilter.find((item) => item.checked)?.value === 'treated';
  const statusFilterValue = statusFilter.find((item) => item.checked)?.label || 'À traiter';

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [tempSearch, setTempSearch] = useState('');
  const [tempStatusFilter, setTempStatusFilter] = useState([...statusFilter]);

  const openFilterSheet = () => {
    setTempSearch(search);
    setTempStatusFilter([...statusFilter]);
    setIsFilterOpen(true);
  };

  const applyFilters = () => {
    setSearch(tempSearch);
    setStatusFilter(tempStatusFilter);
    setIsFilterOpen(false);
  };

  const setTempStatus = (value) => {
    setTempStatusFilter(STATUS_OPTIONS.map((s) => ({ ...s, checked: s.value === value })));
  };

  return (
    <PageForm>
      <SubNavbar>
        <div className="flex justify-between items-center w-full gap-3">
          <MediaQuery minWidth={768}>
            <div className="flex gap-3 items-center min-w-max">
              <FilterDropdown
                value={statusFilterValue}
                list={statusFilter}
                onChange={setStatusFilter}
                type="selectMultipleRadio"
                maxWidth="max-w-[155px]"
                classNameValue="text-sm h-10 px-4 flex items-center justify-center"
              />
              <div className="w-full tab:flex-1 tab:max-w-[400px]">
                <StyledInput
                  type="text"
                  placeholder="Rechercher..."
                  imgFront={<SearchLoop wh={16} color="#6B7280" />}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
          </MediaQuery>

          <MediaQuery maxWidth={767}>
            <Button color="SECONDARY" size="SM" onClick={openFilterSheet}>
              <Filter wh={16} color="#374151" />
              <span>Filtrer</span>
            </Button>
          </MediaQuery>
        </div>
      </SubNavbar>

      <BodyVivierRatingTempWorker treated={treated} search={search} />

      <BottomSheet isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)} title="Filtrer">
        <div className="flex flex-col gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Rechercher</label>
            <StyledInput
              type="text"
              placeholder="Rechercher..."
              imgFront={<SearchLoop wh={16} color="#6B7280" />}
              value={tempSearch}
              onChange={(e) => setTempSearch(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Statut</label>
            <div className="flex gap-4">
              {STATUS_OPTIONS.map((opt) => (
                <label key={opt.value} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="status"
                    checked={tempStatusFilter.find((s) => s.value === opt.value)?.checked}
                    onChange={() => setTempStatus(opt.value)}
                    className="w-4 h-4"
                  />
                  <span className="text-sm">{opt.label}</span>
                </label>
              ))}
            </div>
          </div>
          <div className="mt-2">
            <Button color="PRIMARY" size="FULL" onClick={applyFilters}>Appliquer</Button>
          </div>
        </div>
      </BottomSheet>
    </PageForm>
  );
};

export default VivierRatingTempWorker;
